import React, { useEffect, useMemo } from 'react';
import { AppButton, AppInput, AppSelect } from 'components';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { t } from 'locales';
import api from 'services/api';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { convertToSlug } from '../../utils/slug';

export default function AddLeague() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState({});
  const [countries, setCountries] = useState([]);
  const id = searchParams.get('id');
  const isEdit = !!id;

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset
  } = useForm({
    defaultValues: useMemo(() => {
      return data;
    }, [data])
  });

  useEffect(() => {
    const init = async () => {
      const countriesData = [];
      await api.shared.list('country', 0).then(async res => {
        res.data.map(country => {
          countriesData.push({
            value: country._id,
            label: country.name[0].value
          });
        });
        setCountries(countriesData);
      });
      if (isEdit) {
        await api.shared.get('city', id).then(async res => {
          const data = res.data;
          const editData = {
            name: data.name[0].value,
            country: countriesData.find(
              country => country.value === data.country
            )
          };
          setData(editData);
          reset(editData);
        });
      }
    };
    init();
  }, []);

  const onSubmit = async submitData => {
    setIsLoading(true);
    const params = {
      country: submitData.country.value,
      name: {
        lang: 'en',
        value: submitData.name
      },
      slug: convertToSlug(submitData.name)
    };
    await api.shared[isEdit ? 'update' : 'create']('city', params, id)
      .then(async () => {
        navigate('/city/list');
      })
      .catch(error => console.log('error', error));
    setIsLoading(false);
  };

  return (
    <main className="w-2/5 flex flex-col items-center mx-auto">
      <div className="text-2xl font-bold text-gray-700 mb-2">
        Yeni Şehir Ekle
      </div>
      <div className="text-gray-700 mb-8 text-center">
        Yeni şehir eklemek için bu alandaki formu kullanabilirsiniz. Şehir
        eklerken ülke seçmeyi unutmayın.
      </div>
      <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
        <AppSelect
          options={countries}
          label="Ülke"
          name="country"
          error={errors.league}
          rules={{ required: true }}
          control={control}
          placeholder="Ülke"
        />
        <AppInput
          label="Şehir Adı"
          name="name"
          // @ts-ignore
          error={errors.name}
          rules={{}}
          register={register}
          placeholder="Şehir Adı"
        />
        <AppButton type="submit" className="mt-5" isLoading={isLoading}>
          {t('_general.save')}
        </AppButton>
      </form>
    </main>
  );
}
